/* Keeps the LGG plan selector and the quantity field in lockstep on the product page.
   Without this a shopper can pick "Monthly Subscription (3 Bottles)" while quantity is
   still 1, which renders a wrong per-unit price until the cart guard corrects it.
   Fixing it here means the mismatch never reaches the cart at all. */
(function () {
  var HANDLE = 'lactobacillus-rhamnosus-gg-lgg-probiotic-supplement-30-billion-90-caps';
  if (window.location.pathname.indexOf('/products/' + HANDLE) === -1) return;

  var PLANS = { 1: '691274285345', 2: '691411124513', 3: '691411157281' };
  var QTY_OF = { '691274285345': 1, '691411124513': 2, '691411157281': 3 };

  function planFor(qty) {
    return PLANS[qty] || (qty > 3 ? PLANS[3] : PLANS[1]);
  }

  var syncing = false;

  function qtyFields() {
    return Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"]'));
  }

  function fire(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onPlanChange(radio) {
    var want = QTY_OF[radio.value];
    if (!want) return;
    qtyFields().forEach(function (q) {
      if (parseInt(q.value, 10) === want) return;
      q.value = want;
      fire(q);
    });
  }

  function onQtyChange(field) {
    var qty = parseInt(field.value, 10);
    if (!qty || qty < 1) return;
    var checked = document.querySelector('input[name="selling_plan"]:checked');
    if (!checked || !checked.value) return;
    var want = planFor(qty);
    if (checked.value === want) return;
    var target = document.querySelector('input[name="selling_plan"][value="' + want + '"]');
    if (!target) return;
    target.checked = true;
    fire(target);
  }

  document.addEventListener('change', function (e) {
    if (syncing) return;
    var t = e.target;
    if (!t || t.tagName !== 'INPUT') return;
    syncing = true;
    try {
      if (t.name === 'selling_plan') onPlanChange(t);
      else if (t.name === 'quantity') onQtyChange(t);
    } catch (err) {
      console.warn('[lgg-plan-sync]', err);
    }
    setTimeout(function () { syncing = false; }, 0);
  }, true);
})();
